// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__3zZ-O","left":"StickyBox_left__3iCHT","right":"StickyBox_right__3OUGI"};